"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createElement_1 = require("../../utils/dom/createElement");
const spinner_png_1 = __importDefault(require("../../resources/img/spinner.png"));
class CreatePlaylistModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(onCreateCallback) {
        const modalElement = this.createModalElement();
        this.setCreateHandler(modalElement, onCreateCallback);
        this.setCloseHandler(modalElement);
    }
    close() {
        this.modalService.close();
    }
    createModalElement() {
        return (0, createElement_1.createElement)(`
      <div>
        <div class="playlists-modal">
            <div class="playlists-modal__title">
                Создать плейлист
            </div>
            <div class="playlists-modal__playlist_content">
              <div class="create-playlist__content">
                  <label class="create-playlist__label">
                    Название
                    <input class="create-playlist__input common-input" id="create-playlist-name" type="text">
                  </label>
                  <button class="common-btn create-playlist__btn">Создать</button>
              </div>
            </div>
            <div class="playlists-modal__footer">
                <div class="playlists-modal__close-btn create-playlist__cancel">
                    Отменить
                </div>
            </div>
          <div class="loading loading_hidden modal-loading" id="modal-loading">
            <img class="loading__spinner" src="${spinner_png_1.default}" alt="Идёт загрузка">
          </div>
        </div>
      </div>
    `);
    }
    setCreateHandler(modalElement, onCreateCallback) {
        const button = modalElement.querySelector('.create-playlist__btn');
        if (!button) {
            throw new Error('.create-playlist__btn is not found');
        }
        button.addEventListener('click', async () => {
            const input = document.getElementById('create-playlist-name');
            if (!input) {
                throw new Error('Input with id: create-playlist-name not found');
            }
            if (!(input instanceof HTMLInputElement)) {
                throw new Error('Input element is not instanceof HTMLInputElement');
            }
            const name = input.value.trim();
            if (name !== '') {
                const loadingElement = document.getElementById('modal-loading');
                if (!loadingElement) {
                    throw new Error('Could not find element with id: "modal-loading"');
                }
                loadingElement.classList.remove('loading_hidden');
                await onCreateCallback(name);
                loadingElement.classList.add('loading_hidden');
            }
        });
    }
    setCloseHandler(modalElement) {
        const cancelButton = modalElement.querySelector('.create-playlist__cancel');
        if (!cancelButton) {
            throw new Error('.create-playlist__cancel is not found');
        }
        cancelButton.addEventListener('click', () => this.modalService.close());
        this.modalService.open(modalElement);
    }
}
exports.default = CreatePlaylistModalService;
